import { BaseDecorator } from '../BaseDecorator';
import { ApproveViewElement } from './ApproveViewElement/ApproveViewElement';

export class ApproveModeDecorator extends BaseDecorator {
  decorator(data: Editor.Data.Node.Data, node: HTMLElement) {
    if (data.id) {
      const approvedUsers = data.approvedBy || [];
      if (this.data.permissions.canUserPerform(data.id, 'approve')) {
        const decoration = new ApproveViewElement();
        decoration.setAttribute('contentEditable', 'false');
        decoration.setAttribute('enclosed_element', data.id);
        decoration.setContent(node);
        decoration.setApprovalUsers(approvedUsers);
        if (this.data.approvals.isSelectedForApproval(data.id)) {
          decoration.setAttribute('selected', 'true');
        }
        return decoration;
      }
      if (this.data.nodes.isNodeReadonly(data.id)) {
        if (approvedUsers.length > 0) {
          return this.approveDecorator(data, node);
        }
        return this.readonlyDecorator(data, node);
      }
    }

    return node;
  }
}
